export default {
    EXCEPTION_CODE_FORCE_SIGN_OUT: 900,
    EXCEPTION_CODE_FORCE_CHANGE_POS: 901,
    EXCEPTION_CODE_EXTERNAL_STOCKS: 902,
    EXCEPTION_CODE_CANNOT_LOGIN: 903,
    EXCEPTION_CODE_SAVED_REQUEST_TO_SERVER: 904,

    STATUS_CODE_UNAUTHORIZED: 401
}



// WEBPACK FOOTER //
// ./src/view/constant/ApiResponseConstant.js